import { ImageType } from "../../models/model";
import React from "react";

export const Image = React.memo(
  ({ src, className, alt = "human" }: ImageType) => (
    <img src={src} className={className} alt={alt} />
  )
);
